<!-- @format -->

<div class="reward-card hmf-display-flex hmf-mx-s hmf-mx-m-0">
	<div class="scoreRewardPointsMessageContainer hmf-display-flex hmf-align-items-center hmf-mb-m">
		<img
			src="{{ scoreRewardIcon }}"
			alt="score Reward icon"
			loading="lazy" />
		<div class="hmf-ml-xs">
			<p class="reward-title hmf-header-bold-xs hmf-mb-xxxs">Earn 2X Points</p>
			<p class="reward-details hmf-body-s">
				when you pay with a ScoreRewards credit card. (300 points = $10 Reward).
				<span class="hyperlink info-icon">
					<homefield-icon
						width="16px"
						height="16px"
						name="alert-info-filled"
						class="hmf-display-inline-flex"></homefield-icon>
				</span>
			</p>
		</div>
	</div>
</div>
